


















































import {
  ConferenceDoctorDetail,
  ConferenceDoctorMemberRestControllerApi,
  Configuration,
  DoctorPaymentRestControllerApi,
  PaymentOverview
} from '@/types/api-docs'
import Vue from 'vue'
import CreditCardPayment from '@/components/CreditCardPayment.vue'

const conferenceDoctorApi = new ConferenceDoctorMemberRestControllerApi(
    new Configuration({ basePath: `${window.location.origin}` })
)

const paymentApi = new DoctorPaymentRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export type DataType = {
  pageName: string
  breadcrumbs: unknown[]
  payment?: PaymentOverview
  paymentId: number
  user?: ConferenceDoctorDetail
  paymentResult?: string
}

export type BreadcrumbsRow = {
  text: string
  href: string
  disabled: boolean
}

export default Vue.extend({
  components: { CreditCardPayment },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: this.$store.getters.preRoute?.meta.title || '支払情報',
          href: this.$store.getters.preRoute?.name ? this.$store.getters.preRoute?.path : '/member/payments',
          disabled: !this.$store.getters.preRoute?.name,
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      payment: undefined,
      paymentId: Number(this.$route.params.id),
      user: undefined,
      paymentResult: ''
    }
  },
  async mounted() {
    this.replaceSecondBreadcrumb()
    await this.fetchPayment()
    await this.fetchMember()
  },
  methods: {
    async fetchPayment() {
      const { data } = await paymentApi.fetchDoctorPaymentOverview(this.paymentId)
      this.payment = data
      this.paymentResult = data.paymentResult
      if (this.paymentResult !== undefined && this.paymentResult.length > 0) {
        if (this.paymentResult.indexOf('success') > -1) {
          alert('決済が完了しました')
        } else {
          alert('決済が失敗しました')
        }
      }
    },
    async fetchMember() {
      const { data } = await conferenceDoctorApi.fetchConferenceDoctorDetail(this.payment?.conferenceDoctorsId)
      this.user = data
    },
    canPayment() {
      if (!this.payment) {
        return false
      }

      if (this.payment.billAmount == 0) {
        return false
      }

      if (
        this.payment.paymentStatus !== '未払い' &&
        this.payment.paymentStatus !== 'カードエラー' &&
        this.payment.paymentStatus !== '銀行振込(バーチャル口座)エラー'
      ) {
        return false
      }

      return true
    },
    replaceSecondBreadcrumb() {
      if (this.breadcrumbs.length < 2) {
        return
      }
      let row = this.breadcrumbs[1] as unknown as BreadcrumbsRow
      if (!row.disabled) {
        return
      }

      let pathElems = this.$route.path.split('/')
      const paymentType = pathElems.slice(-2)[0]
      pathElems.splice(pathElems.length - 1, 1)
      row.text = this.judgePageTitle(paymentType)
      row.href = pathElems.join('/')
      row.disabled = false

      this.breadcrumbs.splice(1, 1, row)
    },
    judgePageTitle(paymentType: string): string {
      if (paymentType === 'annualFees') {
        return '年会費一覧'
      } else if (paymentType === 'qualifications') {
        return '資格・認定入金一覧'
      } else if (paymentType === 'etcs') {
        return 'その他入金一覧'
      }
      return '支払情報'
    },
  },
})
